import { useCallback } from 'react';
import { AppExceptionResponse } from '../../../hooks/useHandleAppException';
import LangEnum from '../../../lang/LangEnum';
import snackbarStore from '../../../stores/Snackbar.store';
import useOAuthErrorMessage from './useOAuthErrorMessage';

const useOAuthRequestError = (onExpired: (errorMessage: string) => void) => {
  const resolveErrorMessage = useOAuthErrorMessage();

  return useCallback(
    (response: unknown) => {
      const message = resolveErrorMessage(response);
      const isRequestExpired =
        (response as AppExceptionResponse).data?.code ===
        LangEnum.API_EXCEPTION_OAUTH_REQUEST_EXPIRED;

      if (isRequestExpired) {
        onExpired(message);
        return;
      }

      snackbarStore.handleMessage({ type: 'error', message });
    },
    [onExpired, resolveErrorMessage],
  );
};

export default useOAuthRequestError;
